var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f90669;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.52,54.1h0c-2.91-7.03-9.48-11.44-16.59-11.93-.14,4.51-1.21,8.85-3.12,12.82,3.24-.89,6.73.76,8.05,3.94,1.43,3.45-.22,7.43-3.67,8.86l-6.26,2.59-2.59-6.26c-.24-.57-.39-1.16-.46-1.74-.41.46-.84.92-1.28,1.36l-8.54,8.54,6.05,14.6,17.93-7.43c9.9-4.1,14.6-15.45,10.5-25.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.07,34.23c3.82-3.82,10.03-3.82,13.85,0,3.82,3.82,3.82,10.03,0,13.85l-6.93,6.93-6.93-6.93c-3.82-3.82-3.82-10.03,0-13.85M30.18,21.33h0c-10.95,10.95-10.95,28.7,0,39.65l19.82,19.82,19.82-19.82c10.95-10.95,10.95-28.7,0-39.65h0c-10.95-10.95-28.7-10.95-39.65,0h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.41,63.74c-.44-.44-.87-.9-1.28-1.36-.07.59-.22,1.17-.46,1.74l-2.59,6.26-6.26-2.59c-3.45-1.43-5.1-5.4-3.67-8.86,1.32-3.19,4.8-4.83,8.05-3.94-1.91-3.97-2.98-8.31-3.12-12.82-7.11.49-13.68,4.9-16.59,11.93h0c-4.1,9.9.6,21.25,10.5,25.35l17.93,7.43,6.05-14.6-8.54-8.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunities);
export default __webpack_public_path__ + "static/media/Communities.5fb2eccc7fd7d59bf0175145d51de3e5.svg";
export { ForwardRef as ReactComponent };